import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 2rem;
  margin: 0;
`;

export const Description = styled.div`
  width: 100%;
  margin-top: 30px;
  font-size: 1.3rem;
`;

export const ButtonsBox = styled.div`
  margin-top: 45px;
  display: flex;
  justify-content: space-around;

  button:last-child {
    margin-left: 15px;
  }
`;
